import { ImagePlus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Tooltip, TooltipContent, TooltipTrigger,
} from '@/components/ui/tooltip'

interface InlineImageToolbarButtonProps {
  onClick: () => void
}

export function InlineImageToolbarButton({ onClick }: InlineImageToolbarButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon" onClick={onClick} type="button">
          <ImagePlus className="size-[18px]" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Insert image</TooltipContent>
    </Tooltip>
  )
}
